import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../config/api';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, user, loading, logout } = useAuth();
  const [verifying, setVerifying] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Only verify token when accessing protected routes (after initial load)
    const token = localStorage.getItem('token');
    if (token && user && !verifying && !loading) {
      setVerifying(true);
      // Quick verification with timeout
      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error('Timeout')), 2000)
      );
      
      Promise.race([
        api.get('/auth/verify'),
        timeoutPromise
      ])
        .then((response) => {
          if (!response.data.success) {
            logout();
          }
        })
        .catch(() => {
          // If verification fails, logout
          logout();
        })
        .finally(() => {
          setVerifying(false);
        });
    } else if (!token) {
      // No token, don't verify
      setVerifying(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, loading]);

  // Show loading during initial auth restoration or verification
  if (loading || verifying) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;

